import options from './advanced-information.component';

export default {
    selector: 'dtAdvanced',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/advanced-information/index.js